import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendar = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 15,
	viewBox: "0 0 14 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M4 8.48486C4.55228 8.48486 5 8.03715 5 7.48486C5 6.93258 4.55228 6.48486 4 6.48486C3.44772 6.48486 3 6.93258 3 7.48486C3 8.03715 3.44772 8.48486 4 8.48486Z",
			fill: "#999999"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 10.4849C5 11.0371 4.55228 11.4849 4 11.4849C3.44772 11.4849 3 11.0371 3 10.4849C3 9.93258 3.44772 9.48486 4 9.48486C4.55228 9.48486 5 9.93258 5 10.4849Z",
			fill: "#999999"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 8.48486C7.55229 8.48486 8 8.03715 8 7.48486C8 6.93258 7.55229 6.48486 7 6.48486C6.44771 6.48486 6 6.93258 6 7.48486C6 8.03715 6.44771 8.48486 7 8.48486Z",
			fill: "#999999"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 10.4849C8 11.0371 7.55229 11.4849 7 11.4849C6.44771 11.4849 6 11.0371 6 10.4849C6 9.93258 6.44771 9.48486 7 9.48486C7.55229 9.48486 8 9.93258 8 10.4849Z",
			fill: "#999999"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 8.48486C10.5523 8.48486 11 8.03715 11 7.48486C11 6.93258 10.5523 6.48486 10 6.48486C9.44771 6.48486 9 6.93258 9 7.48486C9 8.03715 9.44771 8.48486 10 8.48486Z",
			fill: "#999999"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14 2.98486C14 1.60415 12.8807 0.484863 11.5 0.484863H2.5C1.11929 0.484863 0 1.60415 0 2.98486V11.9849C0 13.3656 1.11929 14.4849 2.5 14.4849H11.5C12.8807 14.4849 14 13.3656 14 11.9849V2.98486ZM1 4.48486H13V11.9849C13 12.8133 12.3284 13.4849 11.5 13.4849H2.5C1.67157 13.4849 1 12.8133 1 11.9849V4.48486ZM2.5 1.48486H11.5C12.3284 1.48486 13 2.15644 13 2.98486V3.48486H1V2.98486C1 2.15644 1.67157 1.48486 2.5 1.48486Z",
			fill: "#999999"
		})
	]
});
const ForwardRef = forwardRef(SvgCalendar);
export default ForwardRef;
